import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { Box, TextField, Button, Typography, Paper, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PhoneAuth = () => {
	const navigate = useNavigate();
	const { signInWithPhone, verifyCode } = useAuth();
	const [phoneNumber, setPhoneNumber] = useState("");
	const [confirmationResult, setConfirmationResult] = useState(null);
	const [code, setCode] = useState("");
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const { user } = useAuth();

	useEffect(() => {
		if (user) {
			setMessage("Phone number verified successfully!");
			navigate("/");
		}
	}, [user]);

	const handleSendCode = async () => {
		try {
			setLoading(true);
			setMessage("");
			const formattedPhone = `+91${phoneNumber.replace(/\D/g, "")}`;
			const result = await signInWithPhone(formattedPhone);
			setConfirmationResult(result);
			setMessage("Verification code sent to your phone");
		} catch (error) {
			console.error("Error sending code:", error);
			setMessage(`Error: ${error.message}`);
		} finally {
			setLoading(false);
		}
	};

	const handleVerifyCode = async () => {
		try {
			setLoading(true);
			setMessage("");
			await verifyCode(confirmationResult, code);
			setMessage("Phone number verified successfully!");
		} catch (error) {
			console.error("Error verifying code:", error);
			setMessage(`Error: ${error.message}`);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Paper sx={{ p: 3, mt: 2, maxWidth: 400, mx: "auto" }}>
			<Typography variant="h5" gutterBottom align="center">
				Sign In
			</Typography>

			{message && (
				<Typography color={message.includes("Error") ? "error" : "success"} sx={{ mb: 2 }}>
					{message}
				</Typography>
			)}

			{!confirmationResult ? (
				<Box>
					<TextField
						fullWidth
						label="Phone Number"
						value={phoneNumber}
						onChange={(e) => setPhoneNumber(e.target.value)}
						placeholder="Enter phone number"
						sx={{ mb: 2 }}
					/>
					<Button fullWidth variant="contained" onClick={handleSendCode} disabled={loading || !phoneNumber}>
						{loading ? <CircularProgress size={24} /> : "Send Verification Code"}
					</Button>
				</Box>
			) : (
				<Box>
					<TextField fullWidth label="Verification Code" value={code} onChange={(e) => setCode(e.target.value)} sx={{ mb: 2 }} />
					<Button fullWidth variant="contained" onClick={handleVerifyCode} disabled={loading || !code}>
						{loading ? <CircularProgress size={24} /> : "Verify Code"}
					</Button>
				</Box>
			)}
		</Paper>
	);
};

export default PhoneAuth;
